export default __webpack_public_path__ + "static/media/mecanizou.4517733c.ico";